var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, Renderer2 } from '@angular/core';
import { AchooInputComponent } from '../achoo-input/achoo-input.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ValidationHandlerService } from '../validation-handler.service';
import { ObjectUtils } from '../../utils/object.utils';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
var AchooFilterBoxComponent = /** @class */ (function (_super) {
    __extends(AchooFilterBoxComponent, _super);
    function AchooFilterBoxComponent(validationHandlerService, devideDetector, renderer) {
        var _this = _super.call(this, validationHandlerService) || this;
        _this.validationHandlerService = validationHandlerService;
        _this.devideDetector = devideDetector;
        _this.renderer = renderer;
        _this.options = [];
        _this.elementDisabled = 'disabled';
        _this.allowDeselect = true;
        _this.disabled = false;
        _this.makeSelectedItemOnTop = true;
        _this.searchable = true;
        _this.closeOptionAfterSelecting = true;
        _this.closeDropdownWithoutFocusing = false;
        _this.virtualScroll = false;
        _this.selectEvent = new EventEmitter();
        _this.openDropDownEvent = new EventEmitter();
        _this.closeDropDownEvent = new EventEmitter();
        return _this;
    }
    AchooFilterBoxComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        // for the first time change model to re-order selected item on top
        if (changes.model) {
            var hasChangeModel = !ObjectUtils.isEquals(changes.model.currentValue, changes.model.previousValue);
            if (this.makeSelectedItemOnTop && changes.model && hasChangeModel && changes.model.currentValue && changes.model.currentValue.length > 0) {
                // waiting for ng-select rendered
                setTimeout(function () {
                    _this.orderOptions(_this.options);
                }, 1000);
            }
        }
    };
    AchooFilterBoxComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        // disable filter option on mobile
        if (this.devideDetector.isMobile()) {
            this.searchable = false;
        }
    };
    AchooFilterBoxComponent.prototype.ngAfterViewInit = function () {
        if (this.ngSelect) {
            var randomId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10);
            this.renderer.setAttribute(this.ngSelect.filterInput.nativeElement, 'id', randomId);
            this.renderer.setAttribute(this.ngSelect.filterInput.nativeElement, 'autocomplete', randomId);
        }
    };
    AchooFilterBoxComponent.prototype.isSelectedItem = function () {
        var _this = this;
        if (!this.options) {
            return false;
        }
        if (!Array.isArray(this.options)) {
            return false;
        }
        var selectedIndex;
        // find the selected option index
        if (this.multiple) {
            selectedIndex = this.options.findIndex(function (opt) { return Array.isArray(_this.model_) && _this.model_.findIndex(function (val) { return val === opt.id; }) >= 0; });
        }
        else {
            selectedIndex = this.options.findIndex(function (opt) { return opt.id === _this.model_; });
        }
        return selectedIndex >= 0;
    };
    AchooFilterBoxComponent.prototype.numOfSelection = function () {
        if (this.multiple) {
            return this.model_.length;
        }
        else {
            return this.model_ ? 1 : 0;
        }
    };
    AchooFilterBoxComponent.prototype.onSelect = function (e) {
        this.selectEvent.emit(e);
        if (this.makeSelectedItemOnTop) {
            this.orderOptions(this.ngSelect.items);
        }
    };
    AchooFilterBoxComponent.prototype.onOpenDopdown = function (e) {
        this.openDropDownEvent.emit(e);
    };
    AchooFilterBoxComponent.prototype.onCloseDopdown = function (e) {
        if (this.closeDropdownWithoutFocusing) {
            this.closeDropDownEvent.emit(e);
        }
    };
    AchooFilterBoxComponent.prototype.onBlur = function (e) {
        this.ngSelect.close();
        this.closeDropDownEvent.emit(e);
    };
    AchooFilterBoxComponent.prototype.onClickOption = function (id, e) {
        if (this.model_ === id && this.allowDeselect) {
            this.ngSelect.clearModel();
            e.stopPropagation();
        }
    };
    /**
     * using this method to update the ng-Select selected item list directly.
     * When modify the ngModel without using ngSelect events(onSelect, change ...)
     * @param val
     */
    AchooFilterBoxComponent.prototype.updateModel = function (val) {
        this.ngSelect.writeValue(val);
    };
    AchooFilterBoxComponent.prototype.orderOptions = function (items) {
        var _this = this;
        // Variable to hold result depending on sort option
        var newItemList = items;
        // Only sort by selection first if nothing else has been specified
        if (!this.preventSortingSelection) {
            // retrieved list selected items
            var selectedOptionItems = items.filter(function (item) { return _this.isSelectedOption(item); });
            // retrieved list unselected items
            var unSelectedOptionItems = items.filter(function (item) { return !_this.isSelectedOption(item); });
            // display selected items in top of the list option
            newItemList = selectedOptionItems.concat(unSelectedOptionItems);
        }
        // clear selected items first
        this.ngSelect.itemsList.clearSelected();
        // updated the new ordered list option
        this.ngSelect.itemsList.setItems(newItemList);
        // marked selected for previous selected items
        this.ngSelect.itemsList.items.forEach(function (item) {
            if (_this.isSelectedOption(item.value)) {
                _this.ngSelect.itemsList.select(item);
            }
        });
    };
    AchooFilterBoxComponent.prototype.isSelectedOption = function (option) {
        if (this.multiple) {
            return this.model_.findIndex(function (val) { return val === option.id; }) >= 0;
        }
        else {
            return this.model_ === option.id;
        }
    };
    AchooFilterBoxComponent.prototype.onMouseOver = function () {
        if (!this.tooltipBox) {
            return;
        }
        this.tooltipBox.disableTooltip = this.ngSelect.isOpen;
    };
    return AchooFilterBoxComponent;
}(AchooInputComponent));
export { AchooFilterBoxComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-filter-box/achoo-filter-box.component.ts.pre-build-optimizer.js